import React from "react";
import { useForm } from "react-hook-form";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const MasterFilterForm = ({ buttonConfig }) => {
  const schema = z.object({
    state: z.string(),
    city: z.string(),
    pincode: z.string(),
  });

  const filterData = buttonConfig.getfilterOption;

  const form = useForm({
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const submit = (data) => {
    filterData(data);
  };

  return (
    <div className="mb-8 w-full items-end">
      <form
        className="flex flex-wrap w-full space-y-3 items-end gap-2"
        onSubmit={form.handleSubmit(submit)}
      >
        <div className={cn("flex w-[173px] flex-col  gap-2")}>
          <label className="text-base text-[#636363]">Pincode</label>
          <input
            placeholder="Type here"
            {...form.register("pincode")}
            className={cn(
              "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
              errors.pincode && "border-[1px] border-red-300",
            )}
          />
        </div>

        <div className={cn("flex w-[173px] flex-col  gap-2")}>
          <label className="text-base text-[#636363]">City</label>
          <input
            placeholder="Type here"
            {...form.register("city")}
            className={cn(
              "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
              errors.city && "border-[1px] border-red-300",
            )}
          />
        </div>

        <div className={cn("flex w-[173px] flex-col  gap-2")}>
          <label className="text-base text-[#636363]">State</label>
          <input
            placeholder="Type here"
            {...form.register("state")}
            className={cn(
              "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
              errors.state && "border-[1px] border-red-300",
            )}
          />
        </div>

        <button
          type="submit"
          className="w-full max-w-[173px]  gap-2 rounded-md bg-[#F2673A] px-6 py-1.5 text-center font-semibold text-white"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default MasterFilterForm;
